<template>
  <div class="allTop">
    <div class="TextBlock">
      <h1 class="text-center">網頁管理後台登入</h1>
      <p class="text-center">Powered by Think-x-Technology</p>
    </div>

    <div class="inputBlock">
      <form>
        <v-text-field
          v-model="user.email"
          append-icon="mdi-account"
          label="請輸入E-mail"
          placeholder="E-mail"
          outlined
          rounded
          :rules="emailRules"
        ></v-text-field>

        <v-text-field
          v-model="user.password"
          :counter="7"
          :rules="nameRules"
          append-icon="mdi-lock"
          label="請輸入密碼"
          placeholder="密碼"
          outlined
          rounded
        ></v-text-field>

        

        <v-btn @click="Login" class="SignBut" rounded color="black" dark>
          Sign in &#129122;
        </v-btn>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 7 || "Name must be less than 7 characters",
      ],
      dialog: false,
      showMenu: false,
      user: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    Login() {
      let vm = this;
      axios
        .post(
          "https://think-x-tech.synology.me/hotel_system/public/api/login",
          vm.user
        )
        .then(function(response) {
          console.log(response);
          console.log("登入成功");
          let str = response.status;
          let token = response.data.token;
          console.log(str);
          console.log(token);
          localStorage.setItem("LoginStatus", str);
          localStorage.setItem("Token", token);
          vm.$router.push({
            path: "/",
            query: {
              Token: response.data.token,
            },
          });
        })
        .catch(function(error) {
          console.log(error);
          console.log("登入錯誤");
          alert("E-mail或密碼錯誤請重新確認");
        });
    },
  },
};
</script>

<style scoped lang="scss">
.allTop {
  padding: 15% 0;
}
.inputBlock {
  margin: 0 40%;
  .text-field_style {
    box-shadow: 1px 1px 1px 1px gray;
  }
  .SignBut {
    float: right;
  }
}
</style>
